import "flatpickr/dist/themes/material_blue.css";
import "../../../assets/scss/datatables.scss";

import * as confirmAction from "../../../store/confirm/action";
import * as loadingAction from "../../../store/loading/action";
import * as messageAction from "../../../store/message/action";

import {
    Button,
    Card,
    CardBody,
    CardTitle,
    Col,
    Container,
    Form,
    FormGroup,
    Input,
    InputGroup,
    Label,
    Modal,
    Nav,
    NavItem,
    NavLink,
    Row,
    TabContent,
    TabPane,
    Table,
} from "reactstrap";
import {
    GET_ACCOUNT,
    GET_ONSHORE_RP_TPA_DAILY_REPORT,
    GET_RP_TPA_DAILY_REPORT,
    SAVE_LIST_EVENT_RP_TPA_DAILY_REPORT,
    SAVE_LIST_SHRINKAGE_RP_TPA_DAILY_REPORT,
    SAVE_ONSHORE_RP_TPA_DAILY_REPORT,
    SAVE_RP_TPA_DAILY_REPORT,
    SAVE_STOCK_RP_TPA_DAILY_REPORT,
    RP_TPA_SEND_MAIL,
    baseUrl,
} from "../../../helpers/url_api_constant";
import { Link, useHistory, useParams } from "react-router-dom";
import React, { createRef, useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { getPermission, getUserToken } from "../../../helpers/auth_helper";
import { post, postUpload } from "../../../helpers/api_helper";

import OveruseByContact from "./OveruseByContact";
import OveruseByShipper from "./OveruseByShipper";
import PropTypes from "prop-types";
import Select from "react-select";
import TableFour from "./TableFour";
import TableOne from "./TableOne";
import TableThree from "./TableThree";
import TableTwo from "./TableTwo";
import logoPttColor from "../../../assets/images/PTT_LogoColor.png";
import moment from "moment";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { flatMapDeep } from "lodash";

function TPADailyDetail(props) {
    // console.log(props);
    let history = useHistory();
    let { pid } = useParams();
    // console.log(pid);
    const tpaDailyReducer = useSelector(reducer => reducer.TPADailyReport);
    const dispatch = useDispatch();
    const permission = getPermission();
    const searchObj = { PID: pid };
    // const createObj = {};
    const tpaDailyPID = { PID: pid };
    const model = {
        PID: pid,
        SUMMARYREPORT_PID: "",
        SUMMARYREPORT_REV: "",
        TPADAILY_APPROVE: null,
        TPADAILY_LEVEL: "",
        SUMMARYREPORT_DATE: new Date(),
        BALANCESHIPPER_NAME: "",
        BALANCESHIPPER_PID: "",
        // SUMMARYREPORT_PID: "",
        REMARK: "",
        LEADERSHIFT_FLAG: 0,
        SIGN_URL: "",
    }

    const listShift = [
        { label: "A", value: "A" },
        { label: "B", value: "B" },
        { label: "C", value: "C" },
        { label: "D", value: "D" },
    ];

    const [modelDevice, setModelDevice] = useState(model);
    // const [createModel, setCreateModel] = useState(createObj);
    const [searchModel, setSearchModel] = useState(searchObj);
    const [pageAdd, setPageAdd] = useState(false);

    const [listUser, setListUser] = useState([]);
    const [dropDownUser, setDropDownUser] = useState(null);
    const [dropDownShift, setDropDownShift] = useState(null);

    //onInit//
    useEffect(function () {
        fetchData();
        // getDataUser();
        // resetSearch();
        // resetModel();
    }, []);
    //onInit//

    const resetModel = () => {
        // setCreateModel(createObj);
        // setDropDownUser(null);
    };

    const gotoMainMenu = () => {
        history.push({
            pathname: "/tpa-daily-report", state: {  // location state
                goBack: true,
            },
        });
    };

    const compare = (a, b) => {
        // console.log(a, b);
        if (a.ALIAS_NAME < b.ALIAS_NAME) {
            return -1;
        }
        if (a.ALIAS_NAME > b.ALIAS_NAME) {
            return 1;
        }
        return 0;
    }

    useEffect(() => {
        // console.log(tpaDailyReducer);
    }, [tpaDailyReducer]);

    //Function CURL
    const resetSearch = () => {
        setSearchModel(searchObj);
        // fetchData(searchObj);
        getDataUser();
    };

    const onSearch = () => {
        // console.log(searchModel);
        fetchData(searchModel);
    };

    const handleSelectDropDownUser = selected => {
        setDropDownUser(selected);
    };

    const handleSelectDropDownShift = selected => {
        setDropDownShift(selected);
    };

    const getDataUser = async () => {
        dispatch(loadingAction.showLoading());
        try {
            let res = await post(GET_ACCOUNT, { UNITNAME: modelDevice.LEADERSHIFT_FLAG == 0 ? "" : "บค.", IS_LEADER_SHIFT: modelDevice.LEADERSHIFT_FLAG == 0 ? true : false });//shift leaderส่งแค่ฝั่งขวา
            // console.log(res);
            let listDataUser = res.data.AccountList.sort(compare).map((obj) => ({ label: obj.DISPLAY_NAME, value: obj.LOGIN_NAME, shift: obj.SHOW_SHIFT, signUrl: obj.SIGN_URL }));

            setListUser(listDataUser);

            if (modelDevice.TPADAILY_APPROVE == null) {
                setDropDownUser(null);
                // setDropDownShift(listShift[0]);
            } else {
                // console.log(listDataUser);
                // console.log(res.data.rpTPADailyList[0].TPADAILY_APPROVE);
                // console.log(listUser.find(obj =>
                //     obj.value == res.data.rpTPADailyList[0].TPADAILY_APPROVE
                // ));
                let user = listDataUser.find(obj => obj.value == modelDevice.TPADAILY_APPROVE);
                // console.log(user);
                setDropDownUser(user);
                // setDropDownShift(listShift[0]);
            }
        } catch (error) {
            dispatch(messageAction.showMessage(error.message));
        }
        dispatch(loadingAction.hideLoading());
    };

    const fetchData = async () => {
        // dispatch(loadingAction.showLoading());
        try {
            // console.log(modelDevice);
            let [res, dataUser] = await Promise.all([
                post(GET_RP_TPA_DAILY_REPORT, searchModel),
                post(GET_ACCOUNT, { UNITNAME: modelDevice.LEADERSHIFT_FLAG == 0 ? "" : "บค.", IS_LEADER_SHIFT: modelDevice.LEADERSHIFT_FLAG == 0 ? true : false }),
            ])
            // console.log(res);
            let data = res.data.rpTPADailyList[0];
            setModelDevice({
                ...data, REMARK: data.REMARK == null ? "" : data.REMARK, TPADAILY_LEVEL: data.TPADAILY_LEVEL == null ? "" : data.TPADAILY_LEVEL
            });

            let listDataUser = dataUser.data.AccountList.sort(compare).map((obj) => ({ label: obj.DISPLAY_NAME, value: obj.LOGIN_NAME, shift: obj.SHOW_SHIFT, signUrl: obj.SIGN_URL }));
            setListUser(listDataUser);
            // console.log(dataUser);
            if (data.TPADAILY_APPROVE == null) {
                // alert('case 1');
                setDropDownUser(null);
            } else {
                // alert('case 2');
                let user = listDataUser.find(obj => obj.value == data.TPADAILY_APPROVE);
                setDropDownUser(user);
            }
        } catch (error) {
            dispatch(messageAction.showMessage(error.message));
        }
        // dispatch(loadingAction.hideLoading());
    };


    // const fetchData = async () => {
    //     dispatch(loadingAction.showLoading());
    //     try {
    //         let res = await post(GET_RP_TPA_DAILY_REPORT, searchModel);
    //         // console.log(res);
    //         let data = res.data.rpTPADailyList[0];
    //         // console.log(data);
    //         setModelDevice({
    //             ...data, REMARK: data.REMARK == null ? "" : data.REMARK, TPADAILY_LEVEL: data.TPADAILY_LEVEL == null ? "" : data.TPADAILY_LEVEL
    //         });
    //     } catch (error) {
    //         dispatch(messageAction.showMessage(error.message));
    //     }
    //     dispatch(loadingAction.hideLoading());
    // };

    const validateForm = () => {
        let bResult = true;

        let element = document.querySelectorAll(".form-require")
        element.forEach(el => {
            if (el.classList.contains("is-invalid")) {
                el.classList.remove('is-invalid')
            }
        }
        );

        if (modelDevice.TPADAILY_APPROVE == "" || modelDevice.TPADAILY_APPROVE == null) {
            document.getElementById("TPADAILY_APPROVE").classList.add('is-invalid');
            bResult = false;
        }

        if (modelDevice.TPADAILY_LEVEL == "" || modelDevice.TPADAILY_LEVEL == null) {
            bResult = false;
        }
        return bResult;
    };

    const sendMail = async (pid) => {
        // console.log(pid)
        dispatch(loadingAction.showLoading());
        try {
            if (validateForm()) {
                let [dataTableOne, dataTableTwo, dataTableThree, dataTableFour, dataDetail] =
                    await Promise.all([
                        post(SAVE_LIST_EVENT_RP_TPA_DAILY_REPORT, tpaDailyReducer.tableOneEventTPA),
                        post(SAVE_STOCK_RP_TPA_DAILY_REPORT, tpaDailyReducer.tableTwoStockTPA),
                        post(SAVE_LIST_SHRINKAGE_RP_TPA_DAILY_REPORT, tpaDailyReducer.tableThreeShrinkageTPA),
                        post(SAVE_ONSHORE_RP_TPA_DAILY_REPORT, tpaDailyReducer.tableFourOnshoreTPA),
                        post(SAVE_RP_TPA_DAILY_REPORT, modelDevice),
                    ]);
                if (dataTableOne.resultCode != 200) {
                    dispatch(messageAction.showMessage(dataTableOne.resultDescription));
                } else if (dataTableTwo.resultCode != 200) {
                    dispatch(messageAction.showMessage(dataTableTwo.resultDescription));
                } else if (dataTableThree.resultCode != 200) {
                    dispatch(messageAction.showMessage(dataTableThree.resultDescription));
                } else if (dataTableFour.resultCode != 200) {
                    dispatch(messageAction.showMessage(dataTableFour.resultDescription));
                } else if (dataDetail.resultCode != 200) {
                    dispatch(messageAction.showMessage(dataDetail.resultDescription));
                } else {
                    // dispatch(loadingAction.showLoading());
                    try {
                        let res = await post(RP_TPA_SEND_MAIL, { TPADAILY_PID: pid });
                        // console.log(res);
                        if (res.resultCode != 200) {
                            dispatch(messageAction.showMessage(res.resultDescription));
                        } else {
                            dispatch(messageAction.showMessage("Sending email."));
                            gotoMainMenu();
                        }

                    } catch (error) {
                        dispatch(messageAction.showMessage(error.message));
                    }
                    // dispatch(loadingAction.hideLoading());
                }
            } else {
                dispatch(messageAction.showMessage("Please complete the sender information."));
            }
        } catch (error) {
            dispatch(messageAction.showMessage(error.message));
        }
        dispatch(loadingAction.hideLoading());
    };

    useEffect(() => {
        // console.log(modelDevice);
    }, [modelDevice]);

    const handlerSaveTPADailyReport = async () => {
        dispatch(loadingAction.showLoading());
        try {
            if (validateForm()) {
                let [dataTableOne, dataTableTwo, dataTableThree, dataTableFour, dataDetail] =
                    await Promise.all([
                        post(SAVE_LIST_EVENT_RP_TPA_DAILY_REPORT, tpaDailyReducer.tableOneEventTPA),
                        post(SAVE_STOCK_RP_TPA_DAILY_REPORT, tpaDailyReducer.tableTwoStockTPA),
                        post(SAVE_LIST_SHRINKAGE_RP_TPA_DAILY_REPORT, tpaDailyReducer.tableThreeShrinkageTPA),
                        post(SAVE_ONSHORE_RP_TPA_DAILY_REPORT, tpaDailyReducer.tableFourOnshoreTPA),
                        post(SAVE_RP_TPA_DAILY_REPORT, modelDevice),
                    ]);
                if (dataTableOne.resultCode != 200) {
                    dispatch(messageAction.showMessage(dataTableOne.resultDescription));
                } else if (dataTableTwo.resultCode != 200) {
                    dispatch(messageAction.showMessage(dataTableTwo.resultDescription));
                } else if (dataTableThree.resultCode != 200) {
                    dispatch(messageAction.showMessage(dataTableThree.resultDescription));
                } else if (dataTableFour.resultCode != 200) {
                    dispatch(messageAction.showMessage(dataTableFour.resultDescription));
                } else if (dataDetail.resultCode != 200) {
                    dispatch(messageAction.showMessage(dataDetail.resultDescription));
                } else {
                    // if (publicMode) {
                    //     let res = await publicSummaryReport();
                    //     if (res.resultCode == 200) {
                    //         getSummyReport();
                    //         dispatch(messageAction.showMessage("Public success."));
                    //     } else {
                    //         dispatch(messageAction.showMessage(res.resultDescription));
                    //     }
                    // } else {
                    dispatch(messageAction.showMessage("Save success."));
                    // }
                }
            } else {
                dispatch(messageAction.showMessage("Please complete the sender information."));
            }
        } catch (error) {
            dispatch(messageAction.showMessage(error.message));
        }
        dispatch(loadingAction.hideLoading());
    };

    const SelectStyle = {
        option: (provided, { data, isDisabled, isFocused, isSelected }) => ({
            ...provided,
            ...isFocused && ({ backgroundColor: '#2E3460' })
        }),
    }

    useEffect(function () {

        let TPADAILY_LEVEL = dropDownUser != null ? dropDownUser.shift : "";
        let TPADAILY_APPROVE = dropDownUser != null ? dropDownUser.value : null;
        let SIGN_URL = dropDownUser != null ? dropDownUser.signUrl : "";
        // let TPADAILY_LEVEL = dropDownShift != null ? dropDownShift.label : null;

        if (modelDevice.LEADERSHIFT_FLAG == 1) {
            setModelDevice(preVent => ({
                ...preVent, TPADAILY_APPROVE: TPADAILY_APPROVE, TPADAILY_LEVEL: preVent.TPADAILY_LEVEL != null || preVent.TPADAILY_LEVEL != "" ? preVent.TPADAILY_LEVEL : "",
                SIGN_URL: SIGN_URL,
            }));
        } else {
            setModelDevice(preVent => ({
                ...preVent, TPADAILY_APPROVE: TPADAILY_APPROVE, TPADAILY_LEVEL: TPADAILY_LEVEL, SIGN_URL: SIGN_URL,
            }));
        }
    }, [dropDownUser]); //dropDownShift

    useEffect(function () {
        getDataUser();

        // if (modelDevice.LEADERSHIFT_FLAG == 1) {
        //     setModelDevice({
        //         ...modelDevice, TPADAILY_LEVEL: "",
        //     })
        // }
        // setModelDevice({
        //     ...modelDevice, TPADAILY_APPROVE: modelDevice.TPADAILY_APPROVE != null ? modelDevice.TPADAILY_APPROVE : null,
        //     TPADAILY_LEVEL: modelDevice.TPADAILY_LEVEL != null || modelDevice.TPADAILY_LEVEL != "" ? modelDevice.TPADAILY_LEVEL : ""
        // })
    }, [modelDevice.LEADERSHIFT_FLAG]);


    useEffect(function () {
        // getDataUser();
        setModelDevice({
            ...modelDevice, TPADAILY_LEVEL: modelDevice.TPADAILY_APPROVE != null ? modelDevice.TPADAILY_LEVEL : "", SIGN_URL: modelDevice.SIGN_URL != null ? modelDevice.SIGN_URL : "",
        })
    }, [modelDevice.TPADAILY_APPROVE]);

    // useEffect(function () {
    //     console.log(modelDevice.SIGN_URL)
    // }, [modelDevice.SIGN_URL]);



    return (
        <React.Fragment>
            {/* <div className="page-content">  */}
            {/* <Container fluid> */}
            {/* <Row> */}
            <Col xl="12" className="align-items-center justify-content-center pb-0">
                <Card>
                    <CardBody>
                        {/* <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                        <h1 className="mb-sm-0 font-size-20">
                                            TPA Daily ( Detail )
                                        </h1>
                                        <div className="page-title-right">
                                            <ol className="breadcrumb m-0">
                                                <li className="breadcrumb-item">
                                                    <Link to="#" style={{ color: "#556ee6" }}>
                                                        Report
                                                    </Link>
                                                </li>
                                                <li className="breadcrumb-item">
                                                    <Link to="/tpa-daily-report" style={{ color: "#556ee6" }}>
                                                        TPA Daily
                                                    </Link>
                                                </li>
                                                <li className="breadcrumb-item active">
                                                    TPA Daily ( Detail )
                                                </li>
                                            </ol>
                                        </div>
                                    </div> */}
                        <Row>
                            <Col
                                sm="6"
                                className="d-flex align-items-center justify-content-start"
                            >
                                <span style={{ fontSize: "17px", color: "#FFFFFF" }}> Date : </span>&nbsp;&nbsp;<span style={{ fontSize: "17px", color: "#556ee6" }}>{modelDevice.SUMMARYREPORT_DATE == undefined ? "" : moment(modelDevice.SUMMARYREPORT_DATE).locale('en')
                                    .format(
                                        "DD/MM/YYYY"
                                    )}</span>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <span style={{ fontSize: "17px", color: "#FFFFFF" }}> Shipper : </span>&nbsp;&nbsp;<span style={{ fontSize: "17px", color: "#556ee6" }}>{modelDevice.BALANCESHIPPER_NAME}</span>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <span style={{ fontSize: "17px", color: "#FFFFFF" }}> Revision : </span>&nbsp;&nbsp;<span style={{ fontSize: "17px", color: "#556ee6" }}>{modelDevice.SUMMARYREPORT_REV}</span>
                            </Col>
                            {/* <hr /> */}

                            <Col
                                sm="6"
                                className="d-flex align-items-center justify-content-end"
                            >
                                <div className="d-grid gap-2 d-md-block">
                                    <Button
                                        onClick={() => gotoMainMenu()}
                                        // className="btn-rounded"
                                        color="secondary"
                                        className="mt-1 mb-0"
                                    >
                                        <i className="fas fa-angle-double-left"></i>
                                        &nbsp; Back
                                    </Button>
                                </div>
                            </Col>
                        </Row>

                        <Row>
                            <div className="media align-items-center mt-2">
                                <img
                                    src={logoPttColor}
                                    alt=""
                                    style={{ maxWidth: "190px" }}
                                    className="mx-auto d-block" //img-thumbnail
                                />
                            </div>
                        </Row>

                        <Row>
                            <label className="d-sm-flex align-items-center justify-content-center mt-2" style={{ fontSize: "18px", color: "#FFFFFF" }}>
                                รายงาน สรุปข้อมูลการบริหารปริมาณก๊าซ สมุดรายวัน และ ความสามารถในการให้บริการรายวันของ Shipper ประจำวันที่ &nbsp;&nbsp;
                                <span style={{ fontSize: "17px", color: "#556ee6" }}>{modelDevice.SUMMARYREPORT_DATE == undefined ? "" : moment(modelDevice.SUMMARYREPORT_DATE).locale('en').add(-1,'day')
                                    .format(
                                        "DD/MM/YYYY"
                                    )}</span>
                            </label>
                        </Row>

                        <Row>
                            <label className="d-sm-flex align-items-center justify-content-start mt-3" style={{ fontSize: "18px", color: "#FFFFFF" }}>
                                1. สรุปข้อมูลการบริหารปริมาณก๊าซในระบบท่อส่งก๊าซธรรมชาติบนบก
                            </label>
                        </Row>

                        <Row>
                            <label className="d-sm-flex align-items-center justify-content-start mt-3 ms-5" style={{ fontSize: "16px", color: "#FFFFFF" }}>
                                ตารางที่ 1 สรุปเหตุการณ์สำคัญที่กระทบต่อการบริหารปริมาณก๊าซ
                            </label>
                        </Row>

                        <TableOne tpaDailyReportPid={pid} readOnly={false} />

                        <Row>
                            <label className="d-sm-flex align-items-center justify-content-start mt-3 ms-5" style={{ fontSize: "16px", color: "#FFFFFF" }}>
                                ตารางที่ 2 ข้อมูลสรุปการบริหารปริมาณก๊าซสำหรับระบบส่งก๊าซธรรมชาติบนบก (ข้อมูล Operation)
                            </label>
                        </Row>

                        <TableTwo tpaDailyReportPid={pid} readOnly={false} />

                        <Row>
                            <label className="d-sm-flex align-items-center justify-content-start mt-3 ms-5" style={{ fontSize: "16px", color: "#FFFFFF" }}>
                                ตารางที่ 3 ข้อมูลปริมาณ Shrinkage Gas และตัวแปรอื่นๆ สำหรับระบบส่งก๊าซธรรมชาติบนบก (ข้อมูล Operation)
                            </label>
                        </Row>

                        <TableThree tpaDailyReportPid={pid} readOnly={false} />

                        <Row>
                            <label className="d-sm-flex align-items-center justify-content-start mt-5" style={{ fontSize: "18px", color: "#FFFFFF" }}>
                                2. สรุปข้อมูลการบริหารสมดุลสำหรับระบบส่งก๊าซธรรมชาติบนบก
                            </label>
                        </Row>

                        <Row>
                            <label className="d-sm-flex align-items-center justify-content-start mt-3 ms-5" style={{ fontSize: "16px", color: "#FFFFFF" }}>
                                ตารางที่ 4 ข้อมูลสรุปการบริหารสมดุลสำหรับระบบส่งก๊าซธรรมชาติบนบก
                            </label>
                        </Row>

                        <TableFour tpaDailyReportPid={pid} readOnly={false} />

                        <Row>
                            <label className="d-sm-flex align-items-center justify-content-start mt-5" style={{ fontSize: "18px", color: "#FFFFFF" }}>
                                3. ข้อมูลคำนวณความสามารถในการให้บริการเกินกำหนดสำหรับจุดที่มีมาตรวัดรายวัน
                            </label>
                        </Row>

                        <Row>
                            <label className="d-sm-flex align-items-center justify-content-start mt-3 ms-5" style={{ fontSize: "16px", color: "#FFFFFF" }}>
                                ตารางที่ 5 ข้อมูลสรุปการใช้ก๊าซของลูกค้า แบ่งตามกลุ่มพื้นที่จุดจ่ายออกต่างๆ
                            </label>
                        </Row>

                        <Row>
                            <OveruseByContact shipperName={modelDevice.BALANCESHIPPER_NAME} shipperPid={modelDevice.BALANCESHIPPER_PID} summaryReportPid={modelDevice.SUMMARYREPORT_PID} />
                        </Row>
                        <Row>
                            <OveruseByShipper shipperName={modelDevice.BALANCESHIPPER_NAME} summaryReportPid={modelDevice.SUMMARYREPORT_PID} />
                        </Row>

                        <Row>
                            <Col sm="9"></Col>
                            <Col sm="3" className="mt-4 ms-0 d-flex align-items-center justify-content-center">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="exampleRadios"
                                    id="shiftLeader"
                                    value="0"
                                    // defaultChecked
                                    checked={modelDevice.LEADERSHIFT_FLAG == 0}
                                    onChange={e => {
                                        setModelDevice({
                                            ...modelDevice,
                                            LEADERSHIFT_FLAG: e.target.value,
                                        });
                                    }}
                                />
                                <label
                                    className="form-check-label ms-2"
                                    htmlFor="shiftLeader"
                                    style={{ fontSize: "14px", color: "#FFFFFF" }}
                                >
                                    Shift Leader
                                </label>

                                <input
                                    className="form-check-input ms-5"
                                    type="radio"
                                    name="exampleRadios"
                                    id="deputation"
                                    value="1"
                                    checked={modelDevice.LEADERSHIFT_FLAG == 1}
                                    onChange={e => {
                                        setModelDevice({
                                            ...modelDevice,
                                            LEADERSHIFT_FLAG: e.target.value,
                                        });
                                    }}
                                />
                                <label
                                    className="form-check-label ms-2"
                                    htmlFor="deputation"
                                    style={{ fontSize: "14px", color: "#FFFFFF" }}
                                >
                                    Deputation
                                </label>
                            </Col>
                        </Row>

                        {modelDevice.LEADERSHIFT_FLAG == 1 && (
                            <Row>
                                <Col sm="9"></Col>
                                <Col sm="3" className="mt-3 ms-0 d-flex align-items-center justify-content-center">
                                    <Input
                                        placeholder="Remark"
                                        type="textarea"
                                        rows="5"
                                        style={{
                                            border: "solid 1px #FFFFFF",
                                            color: "#FFFFFF",
                                        }}
                                        className="form-control"
                                        onChange={e =>
                                            setModelDevice({
                                                ...modelDevice,
                                                REMARK: e.target.value,
                                            })
                                        }

                                        // disabled={
                                        //     qualityModel.QUALITY_STATUS == 0 ||
                                        //     qualityModel.OFFSHORE_STATUS == false
                                        // }
                                        value={modelDevice.REMARK}
                                    />
                                </Col>
                            </Row>
                        )}

                        <AvForm className="needs-validation">
                            <Row className="justify-content-end">
                                <div className="align-items-center mt-3" style={{ width: "480px" }}>
                                    {/* <Col sm="8"></Col>
                                        <Col sm="4" className="mt-4"> */}
                                    {/* <AvForm className="needs-validation"> */}

                                    <Row>
                                        {modelDevice.SIGN_URL != "" && modelDevice.SIGN_URL != undefined && (
                                            <img src={baseUrl + modelDevice.SIGN_URL} alt="Signature not found" width="50" height="100" />
                                            // style={{ backgroundColor: "#FFFFFF" }}
                                        )}
                                    </Row>

                                    <FormGroup className="row mt-2">

                                        <Label className="col-sm-3 col-form-label d-flex align-items-center justify-content-end" style={{ fontSize: "16px", color: "#FFFFFF" }}>
                                            ลงชื่อ
                                        </Label>
                                        <Col sm={9}>
                                            {/* {modelDevice.LEADERSHIFT_FLAG == 0 && ( */}
                                            <Select
                                                id="TPADAILY_APPROVE"
                                                placeholder=""
                                                isClearable={true}
                                                value={dropDownUser}
                                                onChange={handleSelectDropDownUser}
                                                options={listUser}
                                                classNamePrefix="form-require select2-selection"
                                                styles={SelectStyle}
                                            />
                                            {/* )} */}
                                            {/* {modelDevice.LEADERSHIFT_FLAG == 1 && (
                                                            <AvField
                                                                // disabled={readonly == true || userActionType == "(Edit)"}
                                                                name="TPADAILY_APPROVE"
                                                                type="text"
                                                                errorMessage="Enter Approve"
                                                                className="form-control basicborder"
                                                                validate={{ required: { value: true } }}
                                                                // style={{ border: "solid 1px #FFFFFF" }}
                                                                onChange={(e) => setModelDevice(
                                                                    {
                                                                        ...modelDevice,
                                                                        TPADAILY_APPROVE: e.target.value
                                                                    })
                                                                }
                                                                value={modelDevice.TPADAILY_APPROVE}
                                                            />
                                                        )} */}
                                        </Col>
                                    </FormGroup>

                                    <FormGroup className="d-sm-flex align-items-center justify-content-center mt-3 ms-5">
                                        {modelDevice.LEADERSHIFT_FLAG == 1 && (
                                            <>
                                                <Col sm="1">
                                                    <label className="align-items-center mb-0 pb-0" style={{ fontSize: "16px", color: "#FFFFFF" }}>
                                                        Shift</label>
                                                </Col>
                                                <Col sm="2" className="ms-2">
                                                    <AvField
                                                        // disabled={readonly == true || userActionType == "(Edit)"}
                                                        name="TPADAILY_LEVEL"
                                                        type="text"
                                                        errorMessage="Enter Shift"
                                                        className="form-control basicborder"
                                                        validate={{ required: { value: true } }}
                                                        // style={{ border: "solid 1px #FFFFFF" }}
                                                        onChange={(e) => setModelDevice(
                                                            {
                                                                ...modelDevice,
                                                                TPADAILY_LEVEL: e.target.value
                                                            })
                                                        }
                                                        value={modelDevice.TPADAILY_LEVEL}
                                                    />
                                                </Col>
                                                <Col sm="6" className="ms-2">
                                                    <label className="align-items-center mb-0 pb-0" style={{ fontSize: "16px", color: "#FFFFFF" }}>
                                                        System Operator Unit</label>
                                                </Col>

                                            </>
                                        )}
                                        {modelDevice.LEADERSHIFT_FLAG == 0 && (
                                            <label style={{ fontSize: "16px", color: "#FFFFFF" }}>
                                                Shift  {modelDevice.TPADAILY_LEVEL} System Operator Unit
                                            </label>
                                        )}
                                    </FormGroup>

                                    {/* </Col> */}
                                </div>
                            </Row>

                            {/* <Row>
                                        <Col sm="8"></Col>
                                        <Col sm="4">
                                            <FormGroup className="row">

                                                <Col sm={4} />
                                                <Col sm={8} className="d-sm-flex align-items-center justify-content-center mt-3">
                                                    <label style={{ fontSize: "16px", color: "#FFFFFF" }}>
                                                        Shift  {modelDevice.TPADAILY_LEVEL} System Operator Unit
                                                    </label>
                                                </Col>

                                                <Col sm={2} className="d-sm-flex align-items-center justify-content-end mt-3">
                                                    <Select
                                                        placeholder=""
                                                        // isClearable={true}
                                                        value={dropDownShift}
                                                        onChange={handleSelectDropDownShift}
                                                        options={listShift}
                                                        classNamePrefix="select2-selection"
                                                    /> 
                                                </Col>

                                                
                                                <Col sm={5} className="d-sm-flex align-items-center justify-content-start mt-3">
                                                    <label style={{ fontSize: "16px", color: "#FFFFFF" }}>
                                                        System Operator Unit
                                                    </label>
                                                </Col>
                                            </FormGroup>
                                        </Col>
                                    </Row> */}

                            <Row className="mt-5">
                                <div className="d-flex align-items-center justify-content-end">
                                    {/* && modelDevice.BALANCESHIPPER_NAME != "TSO" */}
                                    {permission.eTPA && modelDevice.TPADAILY_APPROVE != null && (
                                        <Button
                                            type="submit"
                                            onClick={() => sendMail(pid)}
                                            color="info"
                                            className="btn w-md ms-2"
                                        >
                                            <i className="mdi mdi-email-send"> </i> &nbsp; Send Mail
                                        </Button>
                                    )}

                                    {permission.eTPA && (
                                        <Button
                                            type="submit"
                                            onClick={() => handlerSaveTPADailyReport()}
                                            color="success"
                                            className="btn w-md ms-2"
                                        >
                                            <i className="bx bx-save"> </i> &nbsp; Save
                                        </Button>
                                    )}

                                </div>
                            </Row>

                        </AvForm>

                    </CardBody>
                </Card>
            </Col>
            {/* </Row> */}
            {/* </Container> */}
            {/* </div > */}
        </React.Fragment >
    );
}

TPADailyDetail.propTypes = {
    t: PropTypes.any,
    tpaDailyReportPid: PropTypes.any,
};


export default TPADailyDetail;
